import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { App } from './App'
import { Auth0ProviderWithNavigate } from './auth/Auth0ProviderWithNavigate'
import './account/account.css'
import { isAccountPreview } from './lib/previewMode'

const domain = import.meta.env.VITE_AUTH0_DOMAIN
const clientId = import.meta.env.VITE_AUTH0_CLIENT_ID

const isPreview = isAccountPreview

async function renderPreview() {
  // Só em dev: sessão falsa + Worker mockado para testar S17/S18.
  const [{ PreviewAuth0Provider }, { installApiMock }] = await Promise.all([
    import('./dev/PreviewAuth0Provider'),
    import('./dev/preview'),
  ])
  installApiMock()
  createRoot(document.getElementById('root')!).render(
    <BrowserRouter>
      <PreviewAuth0Provider>
        <App />
      </PreviewAuth0Provider>
    </BrowserRouter>,
  )
}

if (isPreview) {
  void renderPreview()
} else if (!domain || !clientId) {
  createRoot(document.getElementById('root')!).render(
    <main className="login-page">
      <h1>Default App</h1>
      <p>
        Configure <code>apps/default-spa/.env</code> a partir de{' '}
        <code>.env.example</code>.
      </p>
    </main>,
  )
} else {
  createRoot(document.getElementById('root')!).render(
    <BrowserRouter>
      <Auth0ProviderWithNavigate>
        <App />
      </Auth0ProviderWithNavigate>
    </BrowserRouter>,
  )
}
